import { render, staticRenderFns } from "./DepartmentsChooseDialog.vue?vue&type=template&id=3c91c818&scoped=true"
import script from "./DepartmentsChooseDialog.vue?vue&type=script&lang=ts"
export * from "./DepartmentsChooseDialog.vue?vue&type=script&lang=ts"
import style0 from "./DepartmentsChooseDialog.vue?vue&type=style&index=0&id=3c91c818&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c91c818",
  null
  
)

export default component.exports